import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import PropTypes from "prop-types";

function Timeline({ children, startIndex = 0 }) {
  const carouselRef = React.useRef(null);

  const carouselOptions = React.useMemo(
    () => ({
      loop: false,
      margin: 10,
      nav: true,
      dots: false,
      startPosition: startIndex,
    }),
    [startIndex]
  );

  React.useEffect(() => {
    if (carouselRef.current && typeof carouselRef.current.to === "function") {
      const timer = setTimeout(() => {
        carouselRef.current.to(startIndex, 0);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [startIndex]);

  return (
    <div className="hori-timeline">
      <OwlCarousel
        ref={carouselRef}
        className="owl-theme navs-carousel events"
        id="timeline-carousel"
        {...carouselOptions}
      >
        {children}
      </OwlCarousel>
    </div>
  );
}

Timeline.propTypes = {
  children: PropTypes.node.isRequired,
  startIndex: PropTypes.number,
};

export default Timeline;
